export function FeedbackAdminPage() {
  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <h1 className="h4 mb-0">Feedback</h1>
          <p className="text-muted mb-0">
            Next: port `feedback/templates/feedback/feedback_list.html` and call `/api/feedback/datatables/`.
          </p>
        </div>
      </div>
    </div>
  );
}

